<template>
  <section class="hero has-background-sky-blue-8">
    <div class="hero-body">
      <ImageItem
        v-if="media"
        v-bind="media.image"
        :image-style="imageStyleClass"
        class="hero-image has-text-centered-mobile"
      />
      <div class="container">
        <div class="columns">
          <div class="column is-offset-half is-5">
            <SpriteSymbol
              name="lessmess_app_icon"
              class="svg-image mt-4 is-hidden-mobile"
            />
            <h1
              class="title is-size-banner has-text-weight-bold has-text-primary has-text-centered-mobile"
            >
              {{ title }}
            </h1>
            <div
              v-if="text"
              class="mb-5 has-text-weight-semibold is-size-normal content"
              v-html="text"
            />

            <div class="has-text-centered-mobile">
              <VuepalLink
                v-if="link && link.url"
                class="button has-text-weight-bold is-size-normal mt-5"
                :class="buttonClass"
              >
                {{ link.title }}
              </VuepalLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ParagraphHeroImageFragment } from '#graphql-operations'

const props = defineProps<ParagraphHeroImageFragment>()

defineBlokkli({
  bundle: 'hero_image',
})

const buttonClass = useButtonClass()

const imageNoCropStyle = defineImageStyle({
  type: 'sizes',
  sizes: {
    sm: 400,
    md: 455,
    lg: 455,
    xl: 630,
  },
})

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 630 / 530,
  sizes: {
    sm: 400,
    md: 455,
    lg: 455,
    xl: 630,
  },
})

// @TODO
const imageStyleClass = computed(() => {
  return props.noCrop ? imageNoCropStyle : imageStyle
})
</script>

<style scoped lang="scss">
.hero {
  position: relative;

  .hero-body {
    padding-top: toRem(60);
    padding-bottom: toRem(60);
    position: relative;
    overflow: hidden;

    @include tablet {
      padding-top: toRem(80);
      padding-bottom: toRem(80);
      min-height: calc(410px + 160px);
    }

    @include widescreen {
      padding-top: toRem(120);
      padding-bottom: toRem(100);
      min-height: calc(560px + 220px);
    }
  }

  .hero-image {
    // Mobile styling
    position: relative;
    display: block;
    margin-bottom: toRem(40);
    max-height: 300px;
    width: auto;
    object-fit: contain;
    margin: 0 auto toRem(40);

    @include tablet {
      // Position in the center of the left half
      position: absolute;
      top: toRem(100);
      left: 0;
      width: 50%;
      height: 80%;
      margin: 0;
      padding: 0;
      max-height: none;
      max-width: none;
      object-fit: contain;
      object-position: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    @include widescreen {
      max-height: none;
      left: toRem(120);
      height: 70%;
      top: toRem(140);
    }
  }
}
</style>
